import React from "react";
import { useNavigate } from "react-router-dom";

function SignUp() {
  const navigate = useNavigate();
  function loginForm() {
    navigate("/login");
  }
  return (
    <>
      <div className="signupForm flex flex-col justify-center items-center w-screen h-screen">
        <form className="flex flex-col justify-evenly h-11/12">
          <h2 className="font-bold text-xl my-2">SIGN UP HERE</h2>
          <div>
            <label
              htmlFor="username"
              className=" text-gray-700 text-sm font-bold mb-2"
            >
              Enter your user name
            </label>
            <input
              id="username"
              type="text"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ></input>
          </div>
          <div>
            <label
              htmlFor="email"
              className=" text-gray-700 text-sm font-bold mb-2"
            >
              Enter your Email
            </label>
            <input
              id="email"
              type="email"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ></input>
          </div>
          <div>
            <label
              htmlFor="height"
              className=" text-gray-700 text-sm font-bold mb-2"
            >
              Enter your Height in Centimeter
            </label>
            <input
              id="height"
              type="number"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ></input>
          </div>
          <div>
            <label
              htmlFor="weight"
              className=" text-gray-700 text-sm font-bold mb-2"
            >
              Enter your weight in kilos
            </label>
            <input
              id="weight"
              type="number"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ></input>
          </div>
          <div>
            <label className=" text-gray-700 text-sm font-bold mb-2">
              Create your password
            </label>
            <input
              id="password"
              typeof="password"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ></input>
          </div>
          <div>
            <label className="text-gray-700 text-sm font-bold mb-2">
              Re-enter password
            </label>
            <input
              id="password"
              typeof="password"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ></input>
          </div>
          <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline my-2">
            Sign Up
          </button>
          <button onClick={loginForm}>Login</button>
        </form>
      </div>
    </>
  );
}

export default SignUp;
